import { FunctionComponent } from "react";

import { setupCustomListFunctions, setupValidators } from "../CustomFunctions";
import { useFormApi } from "../hooks";
import { PreviewHeader } from "../Preview/PreviewHeader";
import { registerWidgets } from "../Widgets";
import { FormLayoutWrapper } from "./FormLayoutWrapper";
import { SurveyRendererInner } from "./SurveyRendererInner";

const testMode = process.env.REACT_APP_TEST;

registerWidgets();
setupValidators();
setupCustomListFunctions();

export const SurveyRenderer: FunctionComponent = () => {
  const formApiOutput = useFormApi();
  const {
    expiry,
    submittedDate,
    titleFields,
    setDeveloperPreviewForm,
    formDisplaySettings
  } = formApiOutput;

  if (testMode) {
    return (
      <PreviewHeader setPreviewForm={setDeveloperPreviewForm}>
        <FormLayoutWrapper
          titleFields={titleFields}
          expiry={expiry}
          submittedDate={submittedDate}
          {...formDisplaySettings}
        >
          <SurveyRendererInner {...formApiOutput} />
        </FormLayoutWrapper>
      </PreviewHeader>
    );
  }

  return (
    <FormLayoutWrapper
      titleFields={titleFields}
      expiry={expiry}
      submittedDate={submittedDate}
      {...formDisplaySettings}
    >
      <SurveyRendererInner {...formApiOutput} />
    </FormLayoutWrapper>
  );
};
